import { jwtDecode } from "jwt-decode";
import axiosInstance from './utils/axiosInstance.js';
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';  // To navigate to the main app after login
import './LoginPage.css';  // Add any styles if needed

// Tenant Assets
import { applyTenantConfig } from "./whitelabels/theme.js";

// Components
import {route_login_user} from './constants/BackendRoutes.js';


const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate(); // Hook for navigation  

  const [searchParams] = useSearchParams();
  const tenantPath = searchParams.get("tenant") || "ripcord";

  // Update the CSS variables accrording to the tenant path that set
  // Passed by URL query parameter. e.g. /login?tenant=heater
  // Or set by the sessionStorage when user login successfully.  
  const [config] = useState(() => applyTenantConfig(tenantPath));

  // Handle the login form submission
  const handleLogin = async (e) => {
    e.preventDefault();
    
    try {
      const url = `${route_login_user}`;

      const response = await axiosInstance.post(url, { email, password });
      const { token } = response.data;
      const decoded = jwtDecode(token);
      const userRole = decoded.role;

      if (!userRole) {
        setError('No user role defined');
        return;
      }
    
      // Save login info in sessionStorage
      sessionStorage.setItem('jwtToken', token);

      if (userRole != 'god') {
        // Save the tenant path in sessionStorage for non-god users
        sessionStorage.setItem('tenantPath', decoded.tenantName);
      }

      if (userRole === 'viewer') {
        navigate(`/devices/${decoded.deviceId}`);
      } else {
        navigate('/');
      }
    } catch (error) {
      // Axios throws an error for non-2xx responses
      const errorMessage = error.response?.data?.message || 'Login failed';
      setError(errorMessage);
    }
  };

  return (
    <div className="login-container">
      <div className="login-bar">
        <img 
          src={config.loginLogo}
          alt={config.loginTitle ?? "Company Login"}
          className="login-icon"
        />
      </div>
      <h2 className="login-title">
        {config.loginTitle ?? "Welcome"}
      </h2>
      <form onSubmit={handleLogin}>
        <div className="input-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="input-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <div className="error-message">{error}</div>}
        <button type="submit" className="login-btn">Login</button>
      </form>
    </div>
  );
};

export default LoginPage;
